import { createAction, createAsyncThunk } from "@reduxjs/toolkit";
import type { Dependencies } from "@redux/store";
import type { FundingRequestEligibilityVM } from "@shared-kernel/application/ports/student/student-repository";

export const retrieveFundingRequestEligibility = createAsyncThunk<FundingRequestEligibilityVM, void, { extra: Partial<Dependencies> }>(
  "fundingRequests/retrieveFundingRequestEligibility",
  async (_: void, { extra: { studentRepository } }) => {
    return studentRepository!.fundingRequestEligibility();
  },
);

export const resetRetrieveFundingRequestEligibility = createAction("fundingRequests/resetRetrieveFundingRequestEligibility");
